import React from "react"
import { styled } from "@mui/material/styles"
import { Checkbox } from "@mui/material"

import Agree from "assets/images/buttons/PinkSquareCheckBox.svg"
import Disagree from "assets/images/buttons/GraySquareCheckBox.svg"
import { getLocaleJaOrEnInitialUpper } from "locale.js"

const StyledImg = styled("img")({
  width: "20px",
  height: "20px",
  verticalAlign: "middle",
})

const PinkSquareCheckBox = (props) => {
  const dataGa = "pinkSquareCheckBox" + getLocaleJaOrEnInitialUpper()
  return (
    <Checkbox
      color="default"
      icon={<StyledImg src={Disagree} alt="Disagree" id="disagree" />}
      checkedIcon={<StyledImg src={Agree} alt="Agree" id="agree" />}
      checked={props.checked}
      onChange={props.onChange}
      value={props.value}
      data-ga={dataGa}
    />
  )
}

export default PinkSquareCheckBox
